<template>
  <vue-recaptcha @expired="markRecaptchaAsExpired" @verify="markRecaptchaAsVerified"
    class="d-md-block d-flex justify-content-center mb-4" :sitekey="captchaSiteKey" :theme="'dark'"
    :loadRecaptchaScript="true"></vue-recaptcha>
</template>

<script>
import VueRecaptcha from 'vue-recaptcha'
export default {
  name: 'Captcha',
  props: ['captcha'],
  components: {
    VueRecaptcha
  },
  data () {
    return {
      captchaSiteKey: process.env.CAPTCHA_SITE_KEY
    }
  },
  methods: {
    markRecaptchaAsExpired (response) {
      this.captcha.recaptchaVerified = false
      this.captcha.value = null
    },
    markRecaptchaAsVerified (response) {
      this.captcha.recaptchaVerified = true
      this.captcha.value = response
    }
  }
}

</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/Captcha.vue